import { render } from "./BotonNotificarJuridicaEmbargoPersonaComponent.vue?vue&type=template&id=6a6e97fc"
import script from "./BotonNotificarJuridicaEmbargoPersonaComponent.vue?vue&type=script&lang=js"
export * from "./BotonNotificarJuridicaEmbargoPersonaComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__